module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-Regular-b6c83129be6cea264251ac5a7d5f413f.woff2";